export const POS_SALE_STORAGE_KEY = "sale";

export function saveSaleOnStorage(sale = {}) {
  try {
    const string = JSON.stringify(sale);
    window.localStorage.setItem(POS_SALE_STORAGE_KEY, string);
  } catch (e) {
    console.error('[saveSaleOnStorage] ERRO ao salvar sale:', e, sale);
  }
}

export function getSaleFromStorage() {
  try {
    const string = window.localStorage.getItem(POS_SALE_STORAGE_KEY);

    if (!string) {
      console.warn('[getSaleFromStorage] Nenhuma venda salva');
      return null;
    }

    const sale = JSON.parse(string);

    return sale;
  } catch (e) {
    console.error('[getSaleFromStorage] ERRO ao carregar/parsear sale:', e);
    return null;
  }
}

export function updateClientToSale(data = {}, remove = false) {
  const sale = getSaleFromStorage() || {};

  sale["client"] = remove ? "" : data.id;
  sale["client_name"] = remove ? "" : data.name;

  saveSaleOnStorage(sale);

  return sale;
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/helpers.js